/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const DELETE_CHECK_LOG_LOADING = "DELETE_CHECK_LOG_LOADING";
export const DELETE_CHECK_LOG_REBATE_PROGRAM_DATA =
  "DELETE_CHECK_LOG_REBATE_PROGRAM_DATA";
export const DELETE_CHECK_LOG_FILTER = "DELETE_CHECK_LOG_FILTER";
export const DELETE_CHECK_LOG_USERDEFAULT = "DELETE_CHECK_LOG_USERDEFAULT";
export const SET_ERROR_MESSAGES = "SET_ERROR_MESSAGES";
export const DELETE_CHECK_LOG_RESET_STORE = "DELETE_CHECK_LOG_RESET_STORE";
